<template>
  <section class="home-block">
    <div class="container">
      <div ref="title" class="h2 title">Мы всегда готовы&nbsp;помочь</div>
      <div ref="list" class="list">
        <swiper
          class="hasPagination"
          navigation
          loop
          :pagination="{ clickable: true }"
          :preload-images="false"
          :slides-per-view="'auto'"
          :space-between="24"
          :centered-slides="true"
          @swiper="onSwiper"
        >
          <swiper-slide v-for="item in list" :key="item.title">
            <div class="item no-gutters">
              <div v-if="item.img" class="item__image">
                <img
                  :src="item.img"
                  width="300"
                  height="360"
                  loading="lazy"
                  :alt="item.title"
                />
              </div>
              <div class="item__content d-flex flex-column">
                <div class="item__title h4" v-html="item.title"></div>
                <div class="item__subtitle" v-html="item.subtitle"></div>
                <div class="item__description" v-html="item.description"></div>
                <div
                  v-if="item.buttonModal"
                  class="item__button-modal"
                  @click="popupShow(item)"
                >
                  Читать далее
                </div>
                <div class="item__text mt-auto" v-html="item.who"></div>
                <div class="item__cta">
                  <a
                    href="javascript:void(0)"
                    data-popup-with-chats
                    data-popup-with-chats-title="Связаться со специалистом"
                    class="d-inline-flex"
                    ><span>Связаться</span><i>&rarr;</i></a
                  >
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script>
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
SwiperCore.use([Navigation, Pagination]);
import { gsap } from "gsap";
import { is_touch } from "@/helpers.js";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiper: null,
      list: [
        {
          title: "Осипов Максим",
          subtitle: "ВЭРИ — абсолютно уникальный проект для&nbsp;Москвы!",
          description:
            "Это место, где встречаются динамика современного города и спокойствие природы. ВЭРИ — не просто жилой комплекс, а настоящий уголок гармонии и&nbsp;вдохновения. <br> Особенность этого проекта — невероятное соседство с Главным Ботаническим садом. Представьте себе: прогулки по тенистым аллеям, дыхание свежего воздуха, окруженного зеленью и ароматами цветов, — всё&nbsp;в&nbsp;шаговой доступности от вашего нового дома. Это уникальное сочетание&nbsp;урбанистического комфорта и природной красоты создает особую&nbsp;атмосферу, куда хочется возвращаться снова и снова. <br> Мы постарались передать вам не только роскошь и простор, но и ту неповторимую энергию, которая исходит от этого живого уголка природы. ВЭРИ — это больше, чем жилой комплекс. Это место, где пространство наполнено вдохновением, а каждый день начинается с красоты и гармонии природы.Добро пожаловать в ВЭРИ — там, где природа становится частью вашей жизни и делает каждый момент по-настоящему особенным!",
          buttonModal: true,
          img: require("@/assets/i/html/team/team-1-1.jpg"),
          imgModal: require("@/assets/i/html/team/team-1-1-modal.jpg"),
          who: "Руководитель отдела продаж",
        },
        {
          title: "Максимова<br> Надежда",
          subtitle: "Ипотека — часть вашей комфортной покупки.",
          description:
            "В современных условиях важно не только подобрать подходящую ипотечную программу,&nbsp;но&nbsp;и&nbsp;сформировать условия, максимально соответствующие вашим долгосрочным жизненным и финансовым планам. Индивидуальный подход к каждому клиенту позволяет учесть особенности вашего сценария жизни и финансовой нагрузки, что обеспечивает стабильность и комфорт на всем протяжении кредита. <br> Моя задача — помочь вам сэкономить время и ресурсы, предоставляя решения, адаптированные под ваши потребности. <br> Анализируя все возможные варианты, я подберу оптимальное решение, которое сделает процесс приобретения недвижимости прозрачным, удобным и предсказуемым.",
          buttonModal: true,
          img: require("@/assets/i/html/team/team-4.jpg"),
          imgModal: require("@/assets/i/html/team/team-4-modal.jpg"),
          who: "Менеджер по&nbsp;ипотеке",
        },
        {
          title: "Виталий Никитин",
          subtitle:
            "ВЭРИ — это место, где каждое утро начинается с&nbsp;вдохновения, ведь прямо за&nbsp;вашим окном раскинулся Ботанический сад — настоящий оазис тишины и&nbsp;зелени.",
          description:
            "Представьте себе: прогулки среди цветов и деревьев, свежий воздух, напоённый ароматами гармонии и умиротворения — всё это становится частью вашего каждодневного пространства. <br> Вместе с природой в шаговой доступности — центр города, деловые кварталы и выезд за город — словно драгоценные грани одного сияющего бриллианта, объединенного в идеальное место для жизни. <br> Здесь ваше время не утекает в бесконечных пробках, а течет легко, словно тихий ручей, наполняя ваши дни светом и спокойствием. <br> В ЖК ВЭРИ каждое утро начинается с ощущения гармонии, и каждое мгновение — с&nbsp;благодарности за возможность жить в окружении зелени и красоты. <br> Это ваш личный уголок вдохновения, где каждый день наполняется свежестью природы, а&nbsp;свободное время — это возможность погрузиться в природную сказку и почувствовать себя частью этого волшебства.",
          buttonModal: true,
          img: require("@/assets/i/html/team/team-6.jpg"),
          imgModal: require("@/assets/i/html/team/team-6-modal.jpg"),
          who: "Менеджер по&nbsp;продажам",
        },
        {
          title: "Козлов Андрей",
          subtitle:
            "ВЭРИ — оазис спокойствия в Москве, расположенный рядом с Главным Ботаническим садом.",
          description:
            "Прогулки среди зелени и свежий воздух — буквально у вашего порога. Это не просто жильё, а пространство, наполненное гармонией и вдохновением.",
          img: require("@/assets/i/html/team/team-10.jpg"),
          who: "Менеджер по&nbsp;продажам",
        },
        {
          title: "Зарипов Ирек",
          subtitle: "Пространства, которые раскрываются вживую.",
          description:
            "Иногда глядя на чертежи, трудно полностью представить, как будет ощущаться ваше будущее жилье. Планировки могут казаться сложными или незавершенными — пока не&nbsp;увидишь их в реальности и не почувствуешь их душу. Именно поэтому мы подготовим для&nbsp;вас личную экскурсию, чтобы вы могли заранее почувствовать, как ваш дом вдохновляет, создает уют и заботится о вашем комфорте. Когда вы приходите и видите пространство своими глазами, тогда планы превращаются в ощущение — и вы начинаете ощущать, как ваше пространство оживает, становится частью вашей мечты и ваших желаний. В этот момент словно просыпается особая энергия, и вы поймете, насколько уютно, гармонично и вдохновляюще будет в вашем новом доме. <br> Приглашаем вас на экскурсию — чтобы каждый взгляд, каждое ощущение помогли вам открыть для себя ваш будущий дом, наполненный теплом",
          buttonModal: true,
          img: require("@/assets/i/html/team/team-11.jpg"),
          imgModal: require("@/assets/i/html/team/team-11-modal.jpg"),
          who: "Менеджер по&nbsp;показам",
        },
        {
          title: "Каминский Петр",
          subtitle:
            "Дом начинается не&nbsp;с&nbsp;чертежей, а&nbsp;с&nbsp;ощущений. ",
          description:
            "Линии на бумаге лишь намекают на то, каким будет ваше пространство: насколько оно&nbsp;просторно, как играет в нём свет, какое тепло оно дарит. <br> Когда вы приходите и видите всё своими глазами, планы превращаются в реальность, а&nbsp;пространство — в часть вашей истории. Оно начинает дышать, наполняться вашими мечтами и создавать особую энергию уюта и гармонии. <br> Приглашаем вас на личную экскурсию. Пусть ваш будущий дом откроется вам во всей полноте — как место, где будут рождаться самые тёплые воспоминания.",
          buttonModal: true,
          img: require("@/assets/i/html/team/team-12.jpg"),
          imgModal: require("@/assets/i/html/team/team-12-modal.jpg"),
          who: "Менеджер по&nbsp;показам",
        },
      ],
    };
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
      if (!is_touch()) {
        this.$nextTick(() => {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: this.$el,
                start: "top 90%",
                end: "bottom bottom",
                scrub: 1.5,
              },
            })
            .from(
              gsap.utils.toArray([this.$refs.title, this.$refs.list]),
              {
                y: 150,
                stagger: { each: 0.1 },
              },
              0
            );
        });
      }
    },
    popupShow(item) {
      this.$vfm.show({
        component: "PopupStaff",
        bind: {
          title: item.subtitle,
          image: item.imgModal,
          name: item.title,
          post: item.who,
          description: item.description
        },
      });
    },
  },
};
</script>

<style scoped>
.home-block {
  background: #f9f9f9;
}
.home-block.mt {
  margin-top: 110px;
}
@media (max-width: 767px) {
  .home-block.mt {
    margin-top: 65px;
  }
}
.title {
  margin-bottom: 80px;
  text-align: center;
}
@media (max-width: 1279px) {
  .title {
    margin-bottom: 65px;
  }
}
@media (max-width: 991px) {
  .title {
    margin-bottom: 40px;
  }
}
.item {
  display: flex;
  min-height: 360px;
  background: #fff;
  box-shadow: 0px 0px 80px rgba(0, 0, 0, 0.05);
}
.list .swiper-container {
  overflow: inherit;
}
.list :deep(.swiper-slide) {
  width: 656px;
}
@media (max-width: 767px) {
  .list :deep(.swiper-slide) {
    width: 100%;
  }
  .item {
    min-height: 816px;
    height: 816px;
  }
}
@media (max-width: 575px) {
  .list :deep(.swiper-slide) {
    width: 300px;
  }
}
.item {
  height: 360px;
}
.item__image {
  max-width: 300px;
}
.item__image img {
  width: 100%;
  height: 100%;
  max-height: 360px;
  object-position: top center;
  object-fit: cover;
}
.item__content {
  flex: 1;
  max-width: 359px;
  height: 100%;
  max-height: 360px;
  padding: 20px;
}
.item__title {
  line-height: 1.1111;
  margin-bottom: 20px;
}
.item__subtitle {
  font-family: Oranienbaum;
  font-size: 20px;
  font-weight: 400;
  line-height: 130%;
  margin-bottom: 10px;
}
.item__description {
  margin-bottom: auto;
  width: 100%;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  color: #778378;
}
.item__button-modal {
  font-size: 12px;
  font-weight: 400;
  color: #205640;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
.item__button-modal:hover {
  color: #366753;
}
.item__cta {
  font-weight: normal;
  font-size: 20px;
  margin-top: 14px;
}
.item__cta a {
  text-decoration: none;
}
body.-notouch .item__cta a:hover span {
  text-decoration: underline;
  text-decoration-thickness: 1px;
}
.item__cta i {
  font-style: normal;
  margin-left: 20px;
  transition: transform 0.15s;
}
body.-notouch .item__cta a:hover i {
  transform: translateX(8px);
}

.list [data-swiper-slide-index="1"] .item__description {
  -webkit-line-clamp: 3;
}

.list [data-swiper-slide-index="2"] .item__description {
  -webkit-line-clamp: 2;
}

@media (max-width: 767px) {
  .item {
    display: flex;
    flex-direction: column;
  }

  .item__content {
    max-height: 100%;
    padding: 25px;
  }

  .item__description {
    -webkit-line-clamp: 11;
  }

  .list [data-swiper-slide-index="0"] .item__description {
    -webkit-line-clamp: 9;
  }

  .list [data-swiper-slide-index="1"] .item__description {
    -webkit-line-clamp: 8;
  }

  .list [data-swiper-slide-index="2"] .item__description {
    -webkit-line-clamp: 1;
  }

  .item__button-modal {
    margin-top: auto;
    margin-bottom: 20px;
  }
}
</style>
